<template>
  <div class="contentBox">
    <!-- 侧边菜单容器 -->
    <div class="sidebar-container" :class="{ collapsed: isCollapse }">
      <!-- 折叠/展开按钮 -->
      <div class="collapse-btn" @click="toggleCollapse">
        <i class="el-icon" :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
      </div>

      <!-- 核心菜单 -->
      <el-menu :default-active="activeIndex" unique-opened router class="el-menu-vertical-demo" :collapse="isCollapse"
        collapse-transition @open="handleOpen" @close="handleClose">
        <!-- 首页 -->
        <el-menu-item index="/home">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>

        <!-- 用户信息 -->
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-user-solid"></i>
            <span>用户信息</span>
          </template>
          <el-menu-item index="/userHome">用户管理</el-menu-item>
          <el-submenu index="1-1">
            <template slot="title">
              <span>消息管理</span>
            </template>
            <el-menu-item index="/messagePage">消息列表</el-menu-item>
            <el-menu-item index="/adminMsg">消息管理</el-menu-item>
          </el-submenu>
          <el-menu-item index="/user/virtualUser">虚拟用户</el-menu-item>
          <el-menu-item index="/super/admin">超管列表</el-menu-item>
          <el-menu-item index="/banSpeak">禁言列表</el-menu-item>
          <el-menu-item index="/userRulesTmpl">认证模板</el-menu-item>
          <el-menu-item index="/userRules">用户认证</el-menu-item>
          <el-menu-item index="/userRulesAuth">实名认证</el-menu-item>
          <el-menu-item index="/invitationPage">邀请列表</el-menu-item>
          <el-menu-item index="/appOnlineStats">实时统计</el-menu-item>
          <!-- 排行列表子菜单 -->
          <el-submenu index="1-2">
            <template slot="title">
              <i class="el-icon-s-data"></i>
              <span>排行列表</span>
            </template>
            <!-- 统一用 type 参数，index 序号连续 -->
            <el-menu-item index="/musterRanking/post">内容排行</el-menu-item>
            <el-menu-item index="/musterRanking/points">积分排行榜</el-menu-item>
            <el-menu-item index="/musterRanking/balance">贝壳排行榜</el-menu-item>
            <el-menu-item index="/musterRanking/gift">送礼物排行榜</el-menu-item>
            <el-menu-item index="/musterRanking/receiveGift">收礼物排行榜</el-menu-item>
            <el-menu-item index="/musterRanking/invitation">邀请排行榜</el-menu-item>
          </el-submenu>
        </el-submenu>

        <!-- 广场管理 -->
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>广场管理</span>
          </template>
          <el-menu-item index="/square">广场列表</el-menu-item>
          <!-- 圈子管理子菜单 -->
          <el-submenu index="2-1">
            <template slot="title">
              <span>圈子管理</span>
            </template>
            <el-menu-item index="/circle">圈子列表</el-menu-item>
            <el-menu-item index="/adminCircle">圈子管理</el-menu-item>
            <el-menu-item index="/examineCircle">圈子创建审批</el-menu-item>
            <el-menu-item index="/adminCheckcCricle">圈子设置</el-menu-item>
          </el-submenu>
          <el-menu-item index="/subJect">话题管理</el-menu-item>
          <el-menu-item index="/artsBureau">艺局系统</el-menu-item>
        </el-submenu>

        <!-- 娱乐系统 -->
        <el-submenu index="3">
          <template slot="title">
            <i class="el-icon-orange"></i>
            <span>娱乐系统</span>
          </template>
          <el-menu-item index="/tabgrade">等级列表</el-menu-item>
          <el-menu-item index="/decoration">积分商城</el-menu-item>
          <el-menu-item index="/memberEdit">会员设置</el-menu-item>
          <el-menu-item index="/giftManagement">礼物管理</el-menu-item>
        </el-submenu>

        <!-- 帖子管理 -->
        <el-submenu index="4">
          <template slot="title">
            <i class="el-icon-document"></i>
            <span>帖子管理</span>
          </template>
          <el-submenu index="4-1">
            <template slot="title">
              <span>小秘密管理</span>
            </template>
            <el-menu-item index="/anonymousList">小秘密列表</el-menu-item>
            <el-menu-item index="/anonyConfig">小秘密配置</el-menu-item>
            <el-menu-item index="/anonyReply">小秘密回复</el-menu-item>
          </el-submenu>
          <el-menu-item index="/content">帖子列表</el-menu-item>
          <el-menu-item index="/replyContent">评论列表</el-menu-item>
          <el-menu-item index="/detailReplyContent">评论回复</el-menu-item>
        </el-submenu>

        <!-- 举报管理 -->
        <el-submenu index="5">
          <template slot="title">
            <i class="el-icon-warning-outline"></i>
            <span>举报管理</span>
          </template>
          <el-menu-item index="/cardReport/0">帖子举报</el-menu-item>
          <el-menu-item index="/cardReport/2">圈子投诉</el-menu-item>
          <!-- <el-menu-item index="/cardReport/3">管理投诉</el-menu-item> -->
          <el-menu-item index="/cardReport/4">用户举报</el-menu-item>
          <el-menu-item index="/cardReport/5">评论举报</el-menu-item>
          <el-menu-item index="/cardReport/6">回复评论举报</el-menu-item>
          <el-menu-item index="/cardReport/7">艺局举报</el-menu-item>
        </el-submenu>

        <!-- 钱包管理 -->
        <el-submenu index="6">
          <template slot="title">
            <i class="el-icon-s-finance"></i>
            <span>钱包管理</span>
          </template>
          <el-menu-item index="/giftRecord">赠礼记录</el-menu-item>
          <el-menu-item index="/user/withdraw">用户提现</el-menu-item>
          <el-menu-item index="/runWallet">钱包充值设置</el-menu-item>
        </el-submenu>

        <!-- 用户服务 -->
        <el-submenu index="7">
          <template slot="title">
            <i class="el-icon-s-promotion"></i>
            <span>用户服务</span>
          </template>
          <el-menu-item index="/serveContent">服务中心配置</el-menu-item>
          <el-menu-item index="/adConfig">广告设置</el-menu-item>
          <el-menu-item index="/taskCenterPage">任务中心</el-menu-item>
          <el-menu-item index="/taskLog">任务完成记录</el-menu-item>
          <el-menu-item index="/feedBack">用户反馈</el-menu-item>
          <el-menu-item index="/aboutUs">关于我们</el-menu-item>
        </el-submenu>

        <el-submenu index="8">
          <template slot="title">
            <i class="el-icon-s-tools"></i>
            <span>小程序管理</span>
          </template>
          <el-menu-item index="/userShare">邀请奖励配置</el-menu-item>
          <el-menu-item index="/custRelay">自定义转发配置</el-menu-item>
          <el-menu-item index="/kindReminder">修改昵称限制</el-menu-item>
          <el-menu-item index="/traffic">流量主</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

    <!-- 主内容区域 -->
    <div class="main-content" :class="{ collapsed: isCollapse }">
      <!-- 顶部导航 -->
      <div class="headerNavBox">
        <!-- Logo区域 -->
        <div class="wyqicon">
          <el-image style="width: 33px; height: 33px" :src="require('/public/logo.jpeg')" fit="fit"></el-image>
          <span class="logo-text">网艺圈</span>
        </div>

        <!-- 引入独立的面包屑组件 -->
        <BreadcrumbNav :report-type-map="reportTypeMap" :route-breadcrumb-map="routeBreadcrumbMap"
          @current-page-click="handleCurrentPageClick" />

        <div class="headerRight">
          <div class="systemMsgCls" @click="toMsgPageFn">
            <el-badge :value="systemMsgCount" v-if="systemMsgCount">
              <div style="display: flex;align-items: center;color: #93a2a9;font-size: 12px;">
                <i class="el-icon-bell"></i>
                <span style="margin-left: 10px;">提醒</span>
              </div>
            </el-badge>

            <div style="display: flex;align-items: center;color: #93a2a9;font-size: 12px;" v-else>
              <i class="el-icon-bell"></i>
              <span style="margin-left: 10px;">提醒</span>
            </div>
          </div>


          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              admin<i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="myMine">个人资料</el-dropdown-item> -->
              <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- 路由视图 -->
      <div class="contentBoxCls" :style="{ width: isCollapse ? 'calc(100vw - 110px)' : 'calc(100vw - 260px)' }">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
// 引入独立的面包屑组件
import BreadcrumbNav from './components/BreadcrumbNav'
import { routeBreadcrumbMap, reportTypeMap } from './routerVal.js'
import { getUnreadNoticeCountApi } from '@/api/user'
export default {
  name: 'wyqLayout',
  components: { /* 注册面包屑组件 */ BreadcrumbNav },
  data() {
    return {
      isCollapse: false,
      menuWidth: 200,
      collapseWidth: 64,
      routeBreadcrumbMap,
      reportTypeMap,
      systemMsgCount: 0
    }
  },
  computed: {
    // 匹配当前路由
    activeIndex() {
      const path = this.$route.path
      if (path.startsWith('/cardReport')) return `/cardReport/${this.$route.params.typeId || '0'}`
      return path
    }
  },
  mounted() {
    getUnreadNoticeCountApi().then((res) => {
      if (res.code == 200) {
        this.systemMsgCount = res.data
      }
    }).catch((err) => {
      console.log(err)
    })
    // 自动展开当前路由对应的菜单
    this.$nextTick(() => {
      const menu = this.$el.querySelector('.el-menu-vertical-demo')
      if (menu && this.activeIndex) {
        const parentIndex = this.getParentMenuIndex()
        if (parentIndex) {
          const parentMenu = menu.querySelector(`[index="${parentIndex}"]`)
          parentMenu && parentMenu.click()
        }
      }
    })
  },
  methods: {
    toMsgPageFn() {
      if (this.$route.path !== '/systemMsg') {
        this.$router.push('/systemMsg');
      } else {
        this.$message.info('当前已是该页面')
      }
    },
    // 处理点击当前页面面包屑的事件（可选）
    handleCurrentPageClick(path) {
      // 可添加提示，比如：this.$message.info('当前已是该页面')
      console.log('当前已是该页面:', path)
    },
    handleOpen() { },
    handleClose() { },
    // 退出/个人资料
    handleCommand(command) {
      if (command === 'logOut') {
        this.$store.commit('logout')
        this.$router.push('/login')
      } else if (command === 'myMine') {
        this.$router.push('/mymine')
      }
    },
    // 切换折叠/展开
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    // 获取父菜单索引
    getParentMenuIndex() {
      const routeMap = {
        '/home': '',
        '/userHome': '1',
        '/user/virtualUser': '1',
        '/super/admin': '1',
        '/userRules': '1',
        '/invitationPage': '1',
        '/appOnlineStats': '1',
        '/circle': '2-1',
        '/square': '2',
        '/subJect': '2',
        '/artsBureau': '2',
        '/tabgrade': '3',
        '/decoration': '3',
        '/memberEdit': '3',
        '/giftManagement': '3',
        '/userShare': '3',
        '/content': '4',
        '/anonymousCircle': '4-1',
        '/replyContent': '4',
        '/detailReplyContent': '4',
        '/banSpeak': '4',
        '/cardReport/0': '5',
        '/cardReport/1': '5',
        '/cardReport/2': '5',
        '/cardReport/3': '5',
        '/cardReport/4': '5',
        '/cardReport/5': '5',
        '/cardReport/6': '5',
        '/giftRecord': '6',
        '/user/withdraw': '6',
        '/runWallet': '6',
        '/serveContent': '7',
        '/adConfig': '7'
      }
      return routeMap[this.activeIndex] || ''
    }
  }
}
</script>

<style lang="scss" scoped>
// 全局容器
.contentBox {
  display: flex;
  height: 100vh;
  background: #E9ECF3;
  overflow: hidden;
}

// 侧边菜单容器
.sidebar-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  padding-top: 70px;
  width: 200px;
  background: #fff;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  z-index: 9;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);

  // 折叠状态
  &.collapsed {
    width: 64px;

    .logo-text {
      display: none;
    }

    .collapse-btn i {
      transform: rotate(180deg);
    }
  }

  // 折叠按钮
  .collapse-btn {
    position: absolute;
    top: 50%;
    right: -16px;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #666;
    transition: all 0.3s ease;

    &:hover {
      background: #f5f5f5;
      color: #409eff;
    }
  }

  // 菜单样式
  .el-menu-vertical-demo {
    border-right: none;
    height: calc(100vh - 56px);
    overflow-y: auto;

    // 滚动条优化
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #eee;
      border-radius: 2px;
    }
  }
}

// 主内容区
.main-content {
  margin-left: 230px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

  // 折叠状态
  &.collapsed {
    margin-left: 94px;
  }

  // 顶部导航
  .headerNavBox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    background: #fff;
    z-index: 99;
    padding: 0 30px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    // Logo样式
    .wyqicon {
      margin-right: 60px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #eee;
      padding: 0 16px;

      .logo-text {
        margin-left: 12px;
        font-weight: 700;
        font-size: 16px;
        color: #333;
        transition: all 0.3s ease;
      }
    }

    .headerRight {
      display: flex;
      align-items: center;

      .systemMsgCls {
        display: flex;
        align-items: center;
        height: 56px;

        padding: 0 20px;
        margin-right: 40px;
      }

      .systemMsgCls:hover {
        background: #edecec;
        cursor: pointer;
      }

      .el-dropdown-link {
        color: #333;
        cursor: pointer;

        &:hover {
          color: #409eff;
        }
      }
    }
  }

  // 内容区域
  .contentBoxCls {
    height: calc(100vh - 96px);
    width: calc(100% - 40px);
    overflow: auto;
    background: #fff;
    padding: 20px;
    margin-top: 72px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

    // 滚动条优化
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 4px;
    }
  }
}

// Element菜单样式覆盖
::v-deep .el-menu-vertical-demo {
  .el-submenu__title {
    height: 48px;
    line-height: 48px;
  }

  .el-menu-item {
    height: 48px;
    line-height: 48px;
  }

  &.el-menu--collapse .el-submenu__title span {
    display: none;
  }
}
</style>
